<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeQuestionnaireSurvey.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <i class="el-icon-plus"></i>{{ $t('committeeQuestionnaireSurvey.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.keyword" :placeholder="$t('committeeQuestionnaireSurvey.search.keywordPlaceholder')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" />
          <el-table-column prop="id" :label="$t('committeeQuestionnaireSurvey.table.id')" min-width="62" show-overflow-tooltip />
          <el-table-column prop="communityName" :label="$t('committeeQuestionnaireSurvey.table.communityName')" min-width="132" show-overflow-tooltip />
          <el-table-column prop="surveyName" :label="$t('committeeQuestionnaireSurvey.table.surveyName')" min-width="174" show-overflow-tooltip />
          <el-table-column prop="surveyDesc" :label="$t('committeeQuestionnaireSurvey.table.surveyDesc')" min-width="143" show-overflow-tooltip />
          <el-table-column prop="organizer" :label="$t('committeeQuestionnaireSurvey.table.organizer')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="contactTel" :label="$t('committeeQuestionnaireSurvey.table.contactTel')" min-width="166" show-overflow-tooltip />
          <el-table-column prop="startTime" :label="$t('committeeQuestionnaireSurvey.table.startTime')" min-width="194" show-overflow-tooltip />
          <el-table-column prop="endTime" :label="$t('committeeQuestionnaireSurvey.table.endTime')" min-width="194" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeQuestionnaireSurvey.table.createTime')" min-width="194" show-overflow-tooltip />
          <el-table-column :label="$t('committeeQuestionnaireSurvey.table.action')" min-width="171" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-links">
                <el-button type="text" size="small" @click="handleDetail(scope.row)">{{ $t('committeeQuestionnaireSurvey.action.detail') }}</el-button>
                <el-button type="text" size="small" :disabled="isLocked(scope.row)" @click="handleEdit(scope.row)">{{ $t('committeeQuestionnaireSurvey.action.edit') }}</el-button>
                <el-button type="text" size="small" :disabled="isLocked(scope.row)" @click="handlePublish(scope.row)">{{ $t('committeeQuestionnaireSurvey.action.publish') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>

    <div v-if="drawerVisible" class="figma-drawer-mask" @click.self="closeDrawer">
      <div class="figma-side-drawer">
        <div class="drawer-header">
          <div class="drawer-title">{{ drawerMode === 'add' ? $t('committeeQuestionnaireSurvey.drawer.addTitle') : drawerMode === 'detail' ? $t('committeeQuestionnaireSurvey.drawer.detailTitle') : $t('committeeQuestionnaireSurvey.drawer.editTitle') }}</div>
        </div>
        <div class="drawer-body">
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.community') }}:</div>
            <el-select v-model="surveyForm.communityId" filterable class="figma-field" placeholder="请选择" :disabled="isDetailMode" @change="handleCommunityChange">
              <el-option v-for="item in myCommunities" :key="item.communityId" :label="item.name" :value="item.communityId" />
            </el-select>
          </div>
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.surveyName') }}:</div>
            <el-input v-model="surveyForm.qaName" class="figma-field" placeholder="请输入" :disabled="isDetailMode" />
          </div>
          <div class="drawer-field">
            <div class="field-label">{{ $t('committeeQuestionnaireSurvey.form.surveyDesc') }}:</div>
            <el-input v-model="surveyForm.content" class="figma-field" placeholder="请输入" :disabled="isDetailMode" />
          </div>
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.organizer') }}:</div>
            <el-select v-if="!isDetailMode" v-model="surveyForm.committeeIds" class="figma-field" placeholder="请选择" style="width: 100%" multiple filterable :disabled="isDetailMode" @change="handleCommitteeChange">
              <el-option
                v-for="(item, idx) in committeeList"
                :key="idx + '-' + (item.id || item.committeeId || item.memberId || item.userId)"
                :label="item.name || item.memberName || item.userName || item.ownerName || item.staffName || item.id"
                :value="item.id || item.committeeId || item.memberId || item.userId"
              />
            </el-select>
            <el-input v-else v-model="surveyForm.organizerName" class="figma-field" placeholder="请输入" disabled />
          </div>
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.contactTel') }}:</div>
            <el-input v-model="surveyForm.organizerTel" class="figma-field" placeholder="请输入" :disabled="isDetailMode" />
          </div>
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.startTime') }}:</div>
            <el-date-picker v-model="surveyForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" class="figma-field" placeholder="请选择" :disabled="isDetailMode" />
          </div>
          <div class="drawer-field required">
            <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.endTime') }}:</div>
            <el-date-picker v-model="surveyForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" class="figma-field" placeholder="请选择" :disabled="isDetailMode" />
          </div>
          <div class="drawer-field">
            <div class="field-label">{{ $t('committeeQuestionnaireSurvey.form.attachment') }}:</div>
            <div class="attachment-area">
              <el-upload v-if="!isDetailMode" class="figma-upload" action="#" :show-file-list="false" :http-request="handleAttachmentUpload">
                <div class="upload-box"><i class="el-icon-plus"></i></div>
              </el-upload>
              <div v-if="surveyForm.attachments.length" class="attachment-count">{{ surveyForm.attachments.length }} 个附件</div>
            </div>
          </div>

          <div class="topic-select-row required">
            <div class="topic-select-box">
              <div class="field-label"><span class="required-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.questionTitle') }}:</div>
              <el-select v-model="surveyForm.titleId" filterable class="topic-select" placeholder="请选择" :disabled="isDetailMode" @change="handleTopicSelect">
                <el-option v-for="item in topicOptions" :key="item.titleId" :label="item.qaTitle" :value="item.titleId" />
              </el-select>
            </div>
            <el-button v-if="!isDetailMode" class="figma-btn-add-topic" @click="openTopicDialog">
              <i class="el-icon-plus"></i>{{ $t('committeeQuestionnaireSurvey.action.addTopic') }}
            </el-button>
          </div>
        </div>
        <div class="drawer-footer">
          <el-button v-if="!isDetailMode" class="drawer-confirm" :loading="drawerSubmitting" @click="submitSurvey">{{ $t('committeeQuestionnaireSurvey.dialog.confirm') }}</el-button>
          <el-button class="drawer-cancel" @click="closeDrawer">{{ isDetailMode ? $t('committeeQuestionnaireSurvey.dialog.close') : $t('committeeQuestionnaireSurvey.dialog.cancel') }}</el-button>
        </div>
      </div>
    </div>

    <div v-if="topicDialogVisible" class="topic-modal-mask">
      <div class="topic-modal">
        <div class="topic-modal-header">
          <div class="topic-modal-title">{{ $t('committeeQuestionnaireSurvey.dialog.addTopicTitle') }}</div>
        </div>
        <div class="topic-modal-body">
          <div class="topic-modal-row required">
            <div class="topic-modal-label"><span class="topic-modal-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.name') }}:</div>
            <el-input v-model="topicForm.qaTitle" class="topic-modal-input" placeholder="请输入" />
          </div>
          <div class="topic-modal-row required">
            <div class="topic-modal-label"><span class="topic-modal-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.type') }}:</div>
            <el-select v-model="topicForm.titleType" class="topic-modal-input" placeholder="请选择" :popper-append-to-body="false" @change="handleTopicTypeChange">
              <el-option :label="$t('committeeQuestionnaireSurvey.topicType.single')" value="1001" />
              <el-option :label="$t('committeeQuestionnaireSurvey.topicType.multi')" value="2002" />
              <el-option :label="$t('committeeQuestionnaireSurvey.topicType.text')" value="3003" />
            </el-select>
          </div>
          <template v-if="topicForm.titleType !== '3003'">
            <div v-for="(option, index) in topicForm.titleValues" :key="index" class="topic-modal-row required">
              <div class="topic-modal-label"><span class="topic-modal-star">*</span> {{ $t('committeeQuestionnaireSurvey.form.option') }}{{ index + 1 }}:</div>
              <div class="topic-option-row">
                <el-input v-model="option.value" class="topic-option-input" placeholder="请输入" />
                <el-button class="topic-option-delete" icon="el-icon-delete" @click="removeTopicOption(index)" />
              </div>
            </div>
            <div class="topic-add-option-wrap">
              <el-button class="topic-add-option" type="text" @click="addTopicOption">+ {{ $t('committeeQuestionnaireSurvey.form.addOption') }}</el-button>
            </div>
          </template>
        </div>
        <div class="topic-modal-footer">
          <el-button class="topic-cancel" @click="topicDialogVisible = false">{{ $t('committeeQuestionnaireSurvey.dialog.cancel') }}</el-button>
          <el-button class="topic-confirm" :loading="topicSubmitting" @click="submitTopic">{{ $t('committeeQuestionnaireSurvey.dialog.confirm') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee, listOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { listQuestionnaireTopics, saveQuestionnaireTopic } from '@/api/committee/questionnaireTopicApi'
import {
  listQuestionnaireSurvey,
  saveQuestionnaireSurvey,
  updateQuestionnaireSurvey,
  publishQuestionnaireSurvey,
  uploadQuestionnaireAttachment
} from '@/api/committee/questionnaireSurveyApi'

export default {
  name: 'CommitteeQuestionnaireSurveyList',
  data() {
    return {
      loading: false,
      conditions: { keyword: '' },
      tableData: [],
      selectedRows: [],
      pagination: { total: 0, page: 1, row: 10 },
      drawerVisible: false,
      drawerMode: 'add',
      drawerSubmitting: false,
      myCommunities: [],
      committeeList: [],
      topicOptions: [],
      surveyForm: this.getDefaultSurveyForm(),
      topicDialogVisible: false,
      topicSubmitting: false,
      topicForm: this.getDefaultTopicForm()
    }
  },
  created() {
    this.loadCommunities().then(() => {
      this.getList()
    })
  },
  computed: {
    isDetailMode() {
      return this.drawerMode === 'detail'
    }
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, fontSize: '14px', height: '50px' } },
    cellStyle({ rowIndex }) { return { fontSize: '14px', fontWeight: 500, background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', height: '50px' } },
    getDefaultSurveyForm() {
      return {
        qaId: '',
        communityId: '',
        qaName: '',
        content: '',
        organizerId: '',
        organizerName: '',
        organizerTel: '',
        startTime: '',
        endTime: '',
        titleId: '',
        questionTitles: [],
        committeeIds: [],
        attachments: []
      }
    },
    getDefaultTopicForm() {
      return { qaTitle: '', titleType: '2002', communityId: (this.surveyForm && this.surveyForm.communityId) || getCommunityId(), titleValues: [{ value: '' }, { value: '' }] }
    },
    isSuccess(res) {
      return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      if (Array.isArray(res && res.questionAnswers)) return res.questionAnswers
      return []
    },
    getTotal(res, list) {
      return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0)
    },
    getDisplayCommunityName(row) {
      try { return row.communityName || getCommunityName() } catch (e) { return row.communityName || '' }
    },
    normalizeSurvey(row, index) {
      return {
        ...row,
        _raw: row,
        id: row.id || row.qaId || index + 1,
        communityName: this.getDisplayCommunityName(row),
        surveyName: row.qaName || row.surveyName || '',
        surveyDesc: row.content || row.surveyDesc || '-',
        organizer: row.organizerName || row.organizer || row.orgName || row.createUserName || '-',
        contactTel: row.organizerTel || row.contactTel || row.tel || row.link || '-',
        startTime: row.startTime || '',
        endTime: row.endTime || '',
        createTime: row.createTime || ''
      }
    },
    normalizeTopic(row) {
      return {
        ...row,
        titleId: row.titleId || row.id,
        qaTitle: row.qaTitle || row.titleName || row.topicName || row.itemTitle || ''
      }
    },
    isLocked(row) {
      return row.state && row.state !== 'W'
    },
    async getList() {
      try {
        this.loading = true
        const res = await listQuestionnaireSurvey({
          page: this.pagination.page,
          row: this.pagination.row,
          qaName: this.conditions.keyword,
          communityIds: this.myCommunities.map(c => c.communityId)
        })
        const list = this.getListArray(res)
        this.tableData = list.map(this.normalizeSurvey)
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error(this.$t('committeeQuestionnaireSurvey.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleSelectionChange(rows) { this.selectedRows = rows },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.myCommunities = res.data || []
      } catch (e) {
        this.myCommunities = []
      }
    },
    async loadTopicOptions() {
      const res = await listQuestionnaireTopics({ page: 1, row: 200, communityIds: this.surveyForm.communityId ? [this.surveyForm.communityId] : [] })
      this.topicOptions = this.getListArray(res).map(item => this.normalizeTopic(item))
    },
    async loadCommittees(communityId) {
      if (!communityId) {
        this.committeeList = []
        return
      }
      try {
        const res = await listOwnerCommittee({ communityId, page: 1, row: 1000 })
        this.committeeList = res.data || []
      } catch (e) {
        this.committeeList = []
      }
    },
    handleCommunityChange() {
      this.surveyForm.committeeIds = []
      this.surveyForm.organizerId = ''
      this.surveyForm.organizerName = ''
      this.surveyForm.organizerTel = ''
      this.loadCommittees(this.surveyForm.communityId)
      this.loadTopicOptions()
    },
    handleCommitteeChange() {
      const ids = []
      const names = []
      this.surveyForm.committeeIds.forEach(id => {
        const item = this.committeeList.find(c => String(c.id || c.committeeId || c.memberId || c.userId) === String(id))
        if (item) {
          ids.push(id)
          names.push(item.name || item.memberName || item.userName || item.ownerName || item.staffName || id)
        }
      })
      this.surveyForm.organizerId = ids.join(',')
      this.surveyForm.organizerName = names.join(',')
    },
    async handleAdd() {
      this.drawerMode = 'add'
      this.surveyForm = this.getDefaultSurveyForm()
      this.surveyForm.communityId = getCommunityId()
      await this.loadCommunities()
      await this.loadCommittees(this.surveyForm.communityId)
      await this.loadTopicOptions()
      this.drawerVisible = true
    },
    async handleEdit(row) {
      if (this.isLocked(row)) return
      this.drawerMode = 'edit'
      await this.loadCommunities()
      await this.loadCommittees(row.communityId || getCommunityId())
      this.surveyForm = {
        ...this.getDefaultSurveyForm(),
        ...row._raw,
        qaId: row.qaId,
        communityId: row.communityId || getCommunityId(),
        qaName: row.surveyName,
        content: row.surveyDesc === '-' ? '' : row.surveyDesc,
        organizerId: row._raw.organizerId || '',
        organizerName: row._raw.organizerName || (row.organizer === '-' ? '' : row.organizer),
        organizerTel: row._raw.organizerTel || (row.contactTel === '-' ? '' : row.contactTel),
        committeeIds: row._raw.committeeIds || [],
        startTime: row.startTime,
        endTime: row.endTime,
        attachments: row.photos ? String(row.photos).split(',').filter(Boolean) : []
      }
      await this.loadTopicOptions()
      const selected = await listQuestionnaireTopics({ page: 1, row: 100, communityIds: this.surveyForm.communityId ? [this.surveyForm.communityId] : [], qaId: row.qaId })
      const titles = this.getListArray(selected).map(this.normalizeTopic)
      this.surveyForm.questionTitles = titles
      this.surveyForm.titleId = titles[0] ? titles[0].titleId : ''
      this.drawerVisible = true
    },
    async handleDetail(row) {
      this.drawerMode = 'detail'
      await this.loadCommunities()
      this.surveyForm = {
        ...this.getDefaultSurveyForm(),
        ...row._raw,
        qaId: row.qaId,
        communityId: row.communityId || getCommunityId(),
        qaName: row.surveyName,
        content: row.surveyDesc === '-' ? '' : row.surveyDesc,
        organizerId: row._raw.organizerId || '',
        organizerName: row._raw.organizerName || (row.organizer === '-' ? '' : row.organizer),
        organizerTel: row._raw.organizerTel || (row.contactTel === '-' ? '' : row.contactTel),
        committeeIds: row._raw.committeeIds || [],
        startTime: row.startTime,
        endTime: row.endTime,
        attachments: row.photos ? String(row.photos).split(',').filter(Boolean) : []
      }
      await this.loadTopicOptions()
      const selected = await listQuestionnaireTopics({ page: 1, row: 100, communityIds: this.surveyForm.communityId ? [this.surveyForm.communityId] : [], qaId: row.qaId })
      const titles = this.getListArray(selected).map(this.normalizeTopic)
      this.surveyForm.questionTitles = titles
      this.surveyForm.titleId = titles[0] ? titles[0].titleId : ''
      this.drawerVisible = true
    },
    handleTopicSelect(titleId) {
      const topic = this.topicOptions.find(item => item.titleId === titleId)
      this.surveyForm.questionTitles = topic ? [topic] : []
    },
    openTopicDialog() {
      this.topicForm = this.getDefaultTopicForm()
      this.topicForm.communityId = this.surveyForm.communityId || getCommunityId()
      this.topicDialogVisible = true
    },
    handleTopicTypeChange(type) {
      if (type !== '3003' && !this.topicForm.titleValues.length) {
        this.topicForm.titleValues = [{ value: '' }, { value: '' }]
      }
    },
    addTopicOption() {
      this.topicForm.titleValues.push({ value: '' })
    },
    removeTopicOption(index) {
      if (this.topicForm.titleValues.length <= 1) return
      this.topicForm.titleValues.splice(index, 1)
    },
    buildTopicPayload() {
      const titleValues = this.topicForm.titleType === '3003' ? [] : this.topicForm.titleValues
        .map((item, index) => ({ seq: index + 1, itemValue: (item.value || '').trim(), qaValue: (item.value || '').trim() }))
        .filter(item => item.itemValue)
      return {
        ...this.topicForm,
        communityId: this.topicForm.communityId || this.surveyForm.communityId || getCommunityId(),
        titleValues
      }
    },
    async submitTopic() {
      if (!this.topicForm.qaTitle) {
        this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.topicName'))
        return
      }
      if (this.topicForm.titleType !== '3003' && !this.topicForm.titleValues.some(item => (item.value || '').trim())) {
        this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.topicOption'))
        return
      }
      try {
        this.topicSubmitting = true
        const res = await saveQuestionnaireTopic(this.buildTopicPayload())
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeQuestionnaireSurvey.message.saveError'))
        this.$message.success(this.$t('committeeQuestionnaireSurvey.message.saveSuccess'))
        this.topicDialogVisible = false
        await this.loadTopicOptions()
        const topic = this.topicOptions.find(item => item.qaTitle === this.topicForm.qaTitle)
        if (topic) {
          this.surveyForm.titleId = topic.titleId
          this.handleTopicSelect(topic.titleId)
        }
      } catch (e) {
        this.$message.error(e.message || this.$t('committeeQuestionnaireSurvey.message.saveError'))
      } finally {
        this.topicSubmitting = false
      }
    },
    async handleAttachmentUpload(option) {
      try {
        const data = new FormData()
        data.append('file', option.file)
        const res = await uploadQuestionnaireAttachment(data)
        const url = (res && (res.url || res.fileUrl || res.data)) || option.file.name
        this.surveyForm.attachments.push(url)
        this.$message.success(this.$t('committeeQuestionnaireSurvey.message.uploadSuccess'))
      } catch (e) {
        this.$message.error(this.$t('committeeQuestionnaireSurvey.message.uploadError'))
      }
    },
    validateSurveyForm() {
      if (!this.surveyForm.communityId) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.community')), false
      if (!this.surveyForm.qaName) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.surveyName')), false
      if (!this.surveyForm.committeeIds || !this.surveyForm.committeeIds.length) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.organizer')), false
      if (!this.surveyForm.organizerTel) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.contactTel')), false
      if (!this.surveyForm.startTime) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.startTime')), false
      if (!this.surveyForm.endTime) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.endTime')), false
      if (new Date(this.surveyForm.startTime) >= new Date(this.surveyForm.endTime)) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.timeRange')), false
      if (!this.surveyForm.questionTitles.length) return this.$message.warning(this.$t('committeeQuestionnaireSurvey.validate.questionTitle')), false
      return true
    },
    buildSurveyPayload() {
      const ids = []
      const names = []
      this.surveyForm.committeeIds.forEach(id => {
        const item = this.committeeList.find(c => String(c.id || c.committeeId || c.memberId || c.userId) === String(id))
        if (item) {
          ids.push(id)
          names.push(item.name || item.memberName || item.userName || item.ownerName || item.staffName || id)
        }
      })
      return {
        ...this.surveyForm,
        surveyName: this.surveyForm.qaName,
        surveyDesc: this.surveyForm.content,
        photos: this.surveyForm.attachments.join(','),
        organizerId: ids.join(','),
        organizerName: names.join(','),
        organizerTel: this.surveyForm.organizerTel
      }
    },
    async submitSurvey() {
      if (!this.validateSurveyForm()) return
      try {
        this.drawerSubmitting = true
        const api = this.drawerMode === 'edit' ? updateQuestionnaireSurvey : saveQuestionnaireSurvey
        const res = await api(this.buildSurveyPayload())
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeQuestionnaireSurvey.message.saveError'))
        this.$message.success(this.$t('committeeQuestionnaireSurvey.message.saveSuccess'))
        this.closeDrawer()
        this.getList()
      } catch (e) {
        this.$message.error(e.message || this.$t('committeeQuestionnaireSurvey.message.saveError'))
      } finally {
        this.drawerSubmitting = false
      }
    },
    handlePublish(row) {
      if (this.isLocked(row)) return
      this.$confirm(this.$t('committeeQuestionnaireSurvey.dialog.publishConfirm'), this.$t('committeeQuestionnaireSurvey.dialog.publishTitle'), { type: 'warning' }).then(async () => {
        const res = await publishQuestionnaireSurvey({ qaId: row.qaId, notifyWay: '3003', communityId: row.communityId })
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeQuestionnaireSurvey.message.publishError'))
        this.$message.success(this.$t('committeeQuestionnaireSurvey.dialog.publishSuccess'))
        this.getList()
      }).catch(e => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    closeDrawer() {
      this.drawerVisible = false
      this.drawerSubmitting = false
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 12px; }
.figma-btn-add { width: 82px; height: 38px; background: #0E76FF !important; border-color: #0E76FF !important; color: white !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; }
.figma-btn-refresh { width: 38px; height: 38px; padding: 0 !important; background: white !important; border-color: #DCE6F5 !important; color: #364153 !important; border-radius: 10px !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input ::v-deep .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; color: #1D2129; }
.figma-search-input ::v-deep .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { width: 84px; height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; }
.figma-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.figma-pagination-section { display: flex; justify-content: flex-end; padding: 16px 24px 24px; flex-shrink: 0; }
.action-links { display: inline-flex; align-items: center; justify-content: center; gap: 14px; white-space: nowrap; }
.action-links ::v-deep .el-button { color: #0E76FF; font-weight: 500; font-size: 14px; }
.action-links ::v-deep .el-button.is-disabled { color: #8C9BB4; }

/* ===== 添加问卷抽屉 ===== */
.figma-drawer-mask { position: fixed; inset: 0; z-index: 2000; background: rgba(0, 0, 0, 0.60); display: flex; justify-content: flex-end; }
.figma-side-drawer { width: 650px; height: 100vh; background: white; display: flex; flex-direction: column; }
.drawer-header { width: 650px; height: 66px; background: #EBF2FA; border-top-left-radius: 12px; flex-shrink: 0; display: flex; align-items: center; padding-left: 24px; border-bottom: 1px solid #DCE6F5; }
.drawer-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; }
.drawer-body { flex: 1; overflow-y: auto; padding: 24px 24px 120px; }
.drawer-body::-webkit-scrollbar { width: 6px; }
.drawer-body::-webkit-scrollbar-thumb { background: #CED9E6; border-radius: 20px; }
.drawer-body::-webkit-scrollbar-track { background: transparent; }

/* 分区标题 */
.drawer-section-title { font-size: 14px; line-height: 20px; color: #1D2129; margin-bottom: 16px; }
.survey-section { font-weight: 400; }
.topic-section { font-weight: 500; margin-top: 24px; }

/* 表单字段 */
.drawer-field { margin-bottom: 20px; }
.field-label { display: block; width: 100%; text-align: left; font-size: 14px; font-weight: 500; color: #1D2129; line-height: 20px; margin-bottom: 14px; font-family: 'PingFang SC'; }
.required-star { color: #FB2C36; }
.figma-field { width: 602px; }
.figma-property-page ::v-deep .figma-field .el-input__inner { height: 38px; line-height: 38px; border-radius: 10px; border: 1px solid #DCE6F5; color: #1D2129; font-size: 14px; }
.figma-property-page ::v-deep .figma-field .el-input__inner:focus { border-color: #0E76FF; }
.figma-property-page ::v-deep .figma-field .el-input__inner::placeholder { color: #8C9BB4; }

/* 附件上传 */
.attachment-area { display: flex; align-items: flex-end; gap: 12px; }
.figma-upload { display: inline-block; }
.figma-upload ::v-deep .el-upload { display: inline-flex; }
.upload-box { width: 82px; height: 82px; background: rgba(14, 118, 255, 0.08); border-radius: 8px; border: 1px solid #0E76FF; display: flex; align-items: center; justify-content: center; color: #0E76FF; font-size: 28px; cursor: pointer; box-sizing: border-box; }
.upload-box:hover { background: rgba(14, 118, 255, 0.14); }
.attachment-count { color: #8C9BB4; font-size: 13px; }

/* 问卷题目行 */
.topic-select-row { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 24px; }
.topic-select-box { width: 452px; }
.topic-select { width: 452px; }
.figma-btn-add-topic { width: 138px; height: 38px; background: #0E76FF !important; border-color: #0E76FF !important; color: #fff !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; flex-shrink: 0; }
.figma-btn-add-topic i { margin-right: 6px; }

/* 底部 */
.drawer-footer { width: 650px; height: 94px; flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding-left: 24px; border-top: 1px solid #DCE6F5; background: #fff; box-sizing: border-box; }
.drawer-confirm { width: 98px; height: 38px; background: #0E76FF !important; border-color: #0E76FF !important; color: #fff !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; }
.drawer-cancel { width: 98px; height: 38px; background: #fff !important; border-color: #0E76FF !important; color: #0E76FF !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; }

/* 问卷题目弹窗 */
.topic-modal-mask { position: fixed; inset: 0; z-index: 2100; background: rgba(0, 0, 0, .6); display: flex; align-items: center; justify-content: center; }
.topic-modal { position: relative; width: 650px; min-height: 470px; background: #fff; border-radius: 12px; overflow: visible; box-shadow: 0 12px 28px rgba(0, 0, 0, .12); display: flex; flex-direction: column; }
.topic-modal ::v-deep .el-select-dropdown { z-index: 2200; }
.topic-modal-header { height: 66px; background: #EBF2FA; display: flex; align-items: center; padding: 22px 24px; border-radius: 12px 12px 0 0; border-bottom: 1px solid #DCE6F5; box-sizing: border-box; }
.topic-modal-title { font-size: 16px; line-height: 22px; font-weight: 600; color: #1D2129; }
.topic-modal-body { flex: 1; padding: 28px 24px 8px; box-sizing: border-box; }
.topic-modal-row { display: flex; align-items: center; margin-bottom: 20px; }
.topic-modal-label { width: 100px; flex-shrink: 0; text-align: right; font-size: 14px; font-weight: 500; color: #1D2129; line-height: 40px; padding-right: 12px; box-sizing: border-box; white-space: nowrap; }
.topic-modal-star { color: #FB2C36; margin-right: 4px; }
.topic-modal-input { width: 502px; }
.topic-modal-input ::v-deep .el-input__inner,
.topic-option-input ::v-deep .el-input__inner { height: 40px !important; line-height: 40px !important; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; padding: 0 32px 0 12px !important; font-size: 14px !important; color: #1D2129; }
.topic-modal-input ::v-deep .el-input__inner::placeholder,
.topic-option-input ::v-deep .el-input__inner::placeholder { color: #8C9BB4; }
.topic-modal-input ::v-deep .el-input__inner:focus,
.topic-option-input ::v-deep .el-input__inner:focus { border-color: #0E76FF !important; }
.topic-modal-input ::v-deep .el-select__caret { line-height: 40px; color: #0E76FF; }
.topic-option-row { display: flex; align-items: center; gap: 8px; width: 502px; }
.topic-option-input { flex: 1; }
.topic-option-delete { width: 40px; height: 40px; padding: 0 !important; border: 1px solid #DCE6F5 !important; border-radius: 10px !important; background: #fff !important; color: #8C9BB4 !important; font-size: 16px !important; }
.topic-option-delete:hover { color: #0E76FF !important; border-color: #0E76FF !important; }
.topic-add-option-wrap { margin-left: 100px; padding-top: 0; }
.topic-add-option { width: 502px; height: 40px; padding: 0 !important; border: 1px dashed #0E76FF !important; border-radius: 10px !important; background: #fff !important; color: #0E76FF !important; font-size: 14px !important; font-weight: 500 !important; }
.topic-modal-footer { display: flex; justify-content: flex-end; gap: 12px; padding: 8px 24px 28px 0; flex-shrink: 0; }
.topic-confirm,
.topic-cancel { width: 98px; height: 38px; padding: 0 !important; border-radius: 10px !important; font-size: 14px !important; font-weight: 500 !important; }
.topic-confirm { background: #0E76FF !important; border-color: #0E76FF !important; color: #fff !important; }
.topic-cancel { background: #fff !important; border-color: #0E76FF !important; color: #0E76FF !important; }

/* 公共覆盖样式 */
.figma-property-page ::v-deep .el-input__inner { height: 38px; line-height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.figma-property-page ::v-deep .el-button { font-size: 14px; font-weight: 500; }
.figma-property-page ::v-deep .el-table th, .figma-property-page ::v-deep .el-table td { padding: 0; }
.figma-property-page ::v-deep .el-table::before { display: none; }
@media (max-width: 768px) {
  .figma-side-drawer { width: 100vw; }
  .figma-field, .topic-select-box, .topic-select { width: 100%; }
  .topic-select-row { display: block; }
  .figma-btn-add-topic { margin-top: 12px; width: 100%; }
}
</style>
